

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.nKyuKhjM.js","_app/immutable/chunks/Z8InAVTp.js","_app/immutable/chunks/BhyBrltq.js","_app/immutable/chunks/0gZYJLaf.js","_app/immutable/chunks/xihTtKlq.js"];
export const stylesheets = [];
export const fonts = [];
